<template>
    <div>
        <meisterschaft-print-header v-if="newPage" :lv-id="bewerb?.settings.lvId">
            <meisterschaft-print-bewerb-name :bewerb="bewerb"/>
        </meisterschaft-print-header>
        <div class="title my-2">Endergebnis</div>
        <meisterschaft-print-ergebnis-tab v-if="newPage" :ergebnis="endergebnis"/>
        <div v-else class="d-flex align-baseline">
            <meisterschaft-print-ergebnis-tab :ergebnis="endergebnis1bis4"
                                              class="d-inline-block mr-5 maxWidth"/>
            <meisterschaft-print-ergebnis-tab :ergebnis="endergebnis5bis8"
                                              class="maxWidth"/>
        </div>
    </div>
</template>

<script>
import MeisterschaftPrintBewerbName from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintBewerbName.vue";
import MeisterschaftPrintHeader from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintHeader.vue";
import MeisterschaftPrintErgebnisTab
    from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintErgebnisTab.vue";

export default {
    name: "meisterschaftPrintErgebnis",
    components: {MeisterschaftPrintErgebnisTab, MeisterschaftPrintHeader, MeisterschaftPrintBewerbName},
    props: ['bewerb', 'newPage'],
    computed: {
        endergebnis(){
            const endergebnis = this.bewerb?.getEndergebnis()
            return endergebnis ? Object.values(endergebnis) : []
        },
        endergebnis1bis4(){
            return this.endergebnis.slice(0,4)
        },
        endergebnis5bis8(){
            return this.endergebnis.slice(4,8)
        }
    },
}
</script>

<style scoped>
    .maxWidth { width: 8cm; }
</style>